import { RANGE_SP } from '@namespace/common/rangeSp'
import { UA_TABLET } from '@namespace/common/uaTablet'
import { UA_CLASS } from '@namespace/common/uaClass'
// import { HEADER } from '@namespace/common/header'
import { GNAV } from '@namespace/common/gnav'
import { LOCATION_CHECK } from '@namespace/common/locationCheck'
import { SMOOTH_SCROLL } from '@namespace/common/smoothScroll'
import { SCROLL_TOP } from '@namespace/common/scrollTop'
// import { SEPARATE_WITH_SPAN } from '@namespace/common/separateWithSpan';
import { PageNavMenu } from '@namespace/common/pageNavMenu'
import { SWIPER } from '@namespace/common/swiper'
import { MODAL } from '@namespace/common/modal'
import { CUSTOM_SETTING } from '@namespace/common/customSetting'
import { CUSTOM_BUTTON } from '@namespace/common/customButton'
import { SELECT } from '@namespace/common/select'
import { COPY_URL } from '@namespace/common/copyUrl'

/**
 * 共通初期化処理
 * - 各モジュールの初期化を一元管理
 */
export default function common() {
  const GLOBALSITE = {
    COMMON: {
      VARIABLES: {
        range_sp: true,
      },
      init() {
        this.RANGE_SP.init(this.VARIABLES)
        this.UA_TABLET.init()
        this.UA_CLASS.init()
        // this.HEADER.init()
        this.GNAV.init(GLOBALSITE)
        this.LOCATION_CHECK.init()
        this.SMOOTH_SCROLL.init()
        this.SCROLL_TOP.init()
        // this.SEPARATE_WITH_SPAN.init();
        this.PageNavMenu.init()
        this.SWIPER.init()
        this.MODAL.init()
        this.CUSTOM_SETTING.init()
        this.CUSTOM_BUTTON.init()
        this.SELECT.init()
        this.COPY_URL.init()
      },
      RANGE_SP,
      UA_TABLET,
      UA_CLASS,
      // HEADER,
      GNAV,
      LOCATION_CHECK,
      SMOOTH_SCROLL,
      SCROLL_TOP,
      // SEPARATE_WITH_SPAN,
      PageNavMenu,
      SWIPER,
      MODAL,
      CUSTOM_SETTING,
      CUSTOM_BUTTON,
      SELECT,
      COPY_URL,
    },
  }

  // DOM構築完了後に初期化
  document.addEventListener('DOMContentLoaded', () => {
    GLOBALSITE.COMMON.init()
  })

  // ページ完全読み込み後に body にクラスを追加
  window.addEventListener('load', () => {
    document.body.classList.add('initialized')
  })
}
